// Copyright (C) 2012-present, The Authors. This program is free software: you can redistribute it and/or  modify it under the terms of the GNU Affero General Public License, version 3, as published by the Free Software Foundation. This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU Affero General Public License for more details. You should have received a copy of the GNU Affero General Public License along with this program.  If not, see <http://www.gnu.org/licenses/>.

import PropTypes from 'prop-types'
import strings from '../../../strings/strings'
import NumberCard from './NumberCard'

const NumberCards = ({ data }) => {
  const averageVotes = (data.voteTimes.length / data.firstVoteTimes.length).toFixed(2)
  return (
    <div>
      <NumberCard
        datum={data.firstVoteTimes.length}
        subheading={strings('mon_participants_voted')}
        icon="users"
      />
      <NumberCard
        datum={data.voteTimes.length}
        subheading={strings('mon_votes_were_cast')}
        icon="tags"
      />
      <NumberCard
        datum={isNaN(averageVotes) ? 0 : Number(averageVotes)}
        subheading={strings('mon_votes_per_participant_average')}
      />
      <NumberCard
        datum={data.firstCommentTimes.length}
        subheading={strings('mon_commented')}
        icon="users"
      />
      <NumberCard
        datum={data.commentTimes.length}
        subheading={strings('mon_comments_submitted')}
        icon="comments"
      />
    </div>
  )
}

NumberCards.propTypes = {
  data: PropTypes.shape({
    firstVoteTimes: PropTypes.arrayOf(PropTypes.number),
    firstCommentTimes: PropTypes.arrayOf(PropTypes.number),
    voteTimes: PropTypes.arrayOf(PropTypes.number),
    commentTimes: PropTypes.arrayOf(PropTypes.number)
  })
}

export default NumberCards
